import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const ToLogout: React.FC = () => {
  return (
    <Page>
      <Container>
        <Row>
          <Column>
            Uspesna odjava.
            <br />
            <StyledLink to="/l-in">Uloguj se</StyledLink>
          </Column>
        </Row>
      </Container>
    </Page>
  );
};

export default ToLogout;

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2em;
`;

const Row = styled.div`
  text-align: center;
`;

const Column = styled.div`
  max-width: 100%;
`;

const StyledLink = styled(Link)`
  display: inline-block;
  margin-top: 1em;
`;

const Page = styled.div`
  height: 100vh;
  width: 100%;
  background-color: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;
`;

// const LogoutLink = styled.a`
//   font-size: 1.1rem;
//   font-weight: 500;
//   text-decoration: none;

//   color: #2c6bed; /* sekundarna boja */
//   padding: 0.5rem 1.5rem;

//   border: 1px solid #2c6bed;
//   border-radius: 4px;

//   transition: background-color 0.15s ease, color 0.15s ease;

//   &:hover {
//     background-color: #2c6bed;
//     color: #ffffff;
//   }
// `;
